import { useMemo } from "react";
import qs from "qs";
import useLocation from "routing/useLocation";
const useQuery = () => {
  const { search } = useLocation();
  return useMemo(() => qs.parse(search, { ignoreQueryPrefix: true }), [search]);
};
export default useQuery;
